import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import { Router } from '@angular/router';
import { PayeeApi } from './shared/sdk/services';
import { Subject } from 'rxjs/Subject';
import { PayeePosOutlet,PayeeService} from './shared/sdk/models';

@Injectable()
export class GlobalEventsManager {

    protected _loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    protected _showNavBar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    protected _showPopUp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    protected _popUpMsg= new Subject<Array<any>>();
    protected _formSave: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    protected _popUpImage= new Subject<Array<any>>();
    protected _saveOutlets= new Subject<boolean>();
    protected _changeBusinessEntity= new Subject<string>();
    
    public showPageEmitter: Observable<boolean> = this._loaded.asObservable();
    public showNavBarEmitter: Observable<boolean> = this._showNavBar.asObservable();
    public showPopUpEmitter: Observable<boolean> = this._showPopUp.asObservable();
    public popUpMsgEmitter: Observable<Array<any>> = this._popUpMsg.asObservable();
    public formSaveEmitter: Observable<boolean> = this._formSave.asObservable();
    public popUpImageEmitter: Observable<Array<any>> = this._popUpImage.asObservable();
    public saveOutletsEmitter: Observable<boolean> = this._saveOutlets.asObservable();
    public changeBusinessEntityEmitter: Observable<string> = this._changeBusinessEntity.asObservable();
    

    public gotMPOS:boolean;
    public onlyQRPay:boolean = false;
    public gotEcomCard:boolean = false;
    public gotPOS:boolean = false;
    public gotCards:boolean = false;
    public submitted: boolean;
    public view: boolean;
    public services_selected_has_form =[];

    public businessEntity: string;
    public firstOutlet:PayeePosOutlet;
    
    constructor(protected router: Router,
                protected userApi: PayeeApi) {}

    showNavBar(ifShow: boolean) {
        this._showNavBar.next(ifShow);
    }

    logout(click?: boolean) {
        if (this.userApi.isAuthenticated()) {
            if (this.router.url == '/form' && !click) {
                this._formSave.next(true);
            } else {
                this.userApi.logout().subscribe(
                    res => { 
                        console.log("logout done");
                        this.showNavBar(false);
                        // 
                    },
                    err => { 
                        console.log("logout fail");
                        this.showNavBar(false);
                        
                    });
            }
        } else {
            this.showNavBar(false);
            this.router.navigate(['/']);

        }

        window.scrollTo(0, 0);
    }

    showPopUpImage(img,number) {
        console.log("showPopUpImage");
        console.log(img);
        // this._showPopUp.next(true);
        this._popUpImage.next([img,null]);
    }

    showPopUp(msg: string) {
        console.log("showPopUp");
        console.log(msg);
        // this._showPopUp.next(true);
        this._popUpMsg.next([msg,null]);
    }

    notSavedPopUp() {
        // this._showPopUp.next(true);
        this._popUpMsg.next(["Don't forget to save your data!",3000]);
    }

    savedPopUp() {
        // this._showPopUp.next(true);
        this._popUpMsg.next(["Form has been saved.",2000]);
        setTimeout(
            () => this._showPopUp.next(false), 
            100 
        );
    }

    failedSavePopUp() {
        // this._showPopUp.next(true);
        this._popUpMsg.next(["Your data has failed to save. Please try again later.",3000]);
    }

    loaded(b: boolean) {
        this._loaded.next(b);
    }

    popUp(string,number){
        // this._showPopUp.next(true);
        this._popUpMsg.next([string,number]);
    }

    saveOutlets(done: boolean){
        this._saveOutlets.next(done);
    }

    changeBusinessEntity(businessEntity: string){
        this.businessEntity = businessEntity;
        this._changeBusinessEntity.next(businessEntity);
    }

    serviceExist(service:number){
        console.log(service)
        console.log(this.services_selected_has_form)
        console.log(this.services_selected_has_form.filter(
          elem => {
            return (elem.id == service) }
        ).length>0)
        return this.services_selected_has_form.filter(
          elem => {
            return (elem.id == service) }
        ).length>0;
    }

    protected _changeBizAcc= new Subject<boolean>();
    public changeBizAccEmitter: Observable<boolean> = this._changeBizAcc.asObservable();
    gotBizAccChanged(changed: boolean){

        this._changeBizAcc.next(changed);


    }

    servicesHasFormSource = new Subject<Array<PayeeService>>();
    servicesHasForm$ = this.servicesHasFormSource.asObservable();
    servicesHasFormChanged(services:Array<PayeeService>) {

        this.servicesHasFormSource.next(services);


    }

}